<template>
  <span>
    <v-btn icon @click="handleShowForm">
      <v-icon small>fas fa-pencil-alt</v-icon>
    </v-btn>

    <v-dialog v-model="showModal" max-width="800" persistent>
      <v-card>
        <v-card-title class="headline">Edit invoice</v-card-title>

        <v-card-text>
          <v-form v-model="isValid" ref="form">
            <div>
              <date-time-input
                label="From"
                :required="true"
                v-model="form.from"
                :max-datetime="form.to"
                :value-post-processor="setTimeToStartOfDay"
                :showNow="false"/>
            </div>

            <div>
              <date-time-input
                label="To"
                :required="true"
                :min-datetime="form.from"
                v-model="form.to"
                :value-post-processor="setTimeToEndOfDay"
                :showNow="false"/>
            </div>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer/>
          <v-btn @click="handleHideForm">Cancel</v-btn>
          <v-btn @click="handleFormSubmit"
                 :disabled="!isSubmitEnabled"
                 :loading="requestInProgress">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
  import {mapActions} from "vuex";
  import {notificationService} from "../../../application";
  import DateTimeInput from "../../Ui/DateTimeInput";
  import {setTimeToEndOfDay, setTimeToStartOfDay} from '../../../helpers/date'
import { isUUID } from '../../../helpers/props';

  function getDefaultFormData(currentFrom, currentTo) {
    return {
      from: currentFrom,
      to: currentTo
    }
  }

  export default {
    name: 'update-invoice-form',
    components: {
      DateTimeInput
    },
    props: {
      invoiceId: {
        value: Number,
        required: true,
      },
      currentFrom: {
        value: Date,
        required: true,
      },
      currentTo: {
        value: Date,
        required: true,
      },
      clientId: {
        value: String,
        required: false,
      },
      costCenterId: {
        value: String,
        required: false,
      },
      regionId: {
        value: String,
        required: false,
      },
    },
    data() {
      return {
        form: getDefaultFormData(this.currentFrom, this.currentTo),
        showModal: false,
        isValid: false,
        requestInProgress: false,
      }
    },
    watch: {
      showModal() {
        if (!this.showModal) {
          this.resetForm()
        }
      }
    },
    computed: {
      isSubmitEnabled() {
        const valid = this.isValid && this.form.from && this.form.to;
        if (!valid) {
          return false
        }
        if (this.$refs.form && !this.$refs.form.validate()) {
          return false
        }

        return true
      }
    },
    methods: {
      ...mapActions({
        invoiceUpdate: 'invoiceUpdate',
      }),
      handleShowForm() {
        this.showModal = true
      },
      handleHideForm() {
        this.showModal = false
      },
      handleFormSubmit() {
        if (!this.isSubmitEnabled) {
          return
        }

        let request = {}

        if (
          this.clientId && 
          this.clientId === '00000000-0000-0000-0000-000000000000' && 
          this.costCenterId && 
          this.regionId
          ) {
            request = {
              invoiceId: this.invoiceId,
              costCenterId: this.costCenterId,
              regionId: this.regionId,
              from: this.form.from,
              to: this.form.to,
            };
        } else {
          request = {
            invoiceId: this.invoiceId,
            from: this.form.from,
            to: this.form.to,
          };
        }

        this.requestInProgress = true;

        this
          .invoiceUpdate(request)
          .then(() => {
            this.requestInProgress = false;
            notificationService.info('Operation success');
            this.resetForm();
            this.showModal = false
          })
          .catch(e => {
            this.requestInProgress = false;
            notificationService.error('Operation failed');
            throw e
          })
      },
      resetForm() {
        this.form = getDefaultFormData(this.currentTo, this.currentTo)
      },
      setTimeToStartOfDay(value) {
        return setTimeToStartOfDay(value)
      },
      setTimeToEndOfDay(value) {
        return setTimeToEndOfDay(value)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/analytics/invoices/UpdateInvoiceForm.vue